import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { signIn } from "../utils/redux/adminSlice";
import { AddUserPersistance } from "../utils/persistance";
import { errorLogger } from "../utils/helpers/errorLogger";
import { useToasts } from "react-toast-notifications";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

const SignInForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addToast } = useToasts();
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: ""
  });
  const [step, setStep] = useState("password"); // "password" | "otp"
  const [pendingAuth, setPendingAuth] = useState({ email: "", uid: "" });
  const [otp, setOtp] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        loginDetails.email,
        loginDetails.password
      );
      const user = userCredential.user;
      const uid = user.uid;
      const res = await axios.post(
        `${process.env.REACT_APP_API_END_POINT}admin/login`,
        {
          email: loginDetails.email,
          uid: uid
        }
      );
      if (res?.data?.requiresOtp) {
        setPendingAuth({ email: loginDetails.email, uid });
        setStep("otp");
        addToast("Enter the code sent to admin email", { appearance: "info" });
      }
    } catch (error) {
      errorLogger(error, addToast);
    } finally {
      setSubmitting(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_END_POINT}admin/verify-otp`,
        {
          email: pendingAuth.email,
          uid: pendingAuth.uid,
          otp
        }
      );
      dispatch(
        signIn({
          userDetails: { ...res?.data?.user },
          accessToken: res?.data?.accessToken
        })
      );
      navigate("/");
      AddUserPersistance(res?.data);
    } catch (error) {
      errorLogger(error, addToast);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setLoginDetails({ ...loginDetails, [e.target.name]: e.target.value });
  };

  if (step === "otp") {
    return (
      <form onSubmit={handleOtpSubmit}>
        <Heading>Enter Verification Code</Heading>
        <Container>
          <InputWrapper>
            <Label>Code sent to admin email:</Label>
            <TextField
              type="text"
              name="otp"
              placeholder="6-digit code"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              inputProps={{ maxLength: 6 }}
            />
          </InputWrapper>
          <Button fullWidth variant="contained" type="submit" disabled={submitting}>
            {submitting ? "Verifying..." : "Verify & Sign In"}
          </Button>
        </Container>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <Heading>Login to Your Account</Heading>
      <Container>
        <InputWrapper>
          <Label>Enter Your Email :</Label>
          <TextField
            type="email"
            name="email"
            placeholder="youremail@gmail.com"
            value={loginDetails.email}
            onChange={handleChange}
          />
        </InputWrapper>
        <InputWrapper>
          <Label>Password :</Label>
          <TextField
            type="password"
            name="password"
            placeholder="********"
            onChange={handleChange}
            value={loginDetails.password}
          />
        </InputWrapper>
        <Button fullWidth variant="contained" type="submit" disabled={submitting}>
          {submitting ? "Signing In..." : "Sign In"}
        </Button>
      </Container>
    </form>
  );
};

export default SignInForm;

const Heading = styled.h1`
  text-align: center;
`;

const Container = styled.div`
  width: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1.5rem;
  margin: 3rem auto;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 400px;
`;

const Label = styled.label`
  font-size: 1.25rem;
  font-weight: 500;
`;